import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const AdminRoute = () => {
  const { user, cargando } = useAuth();

  if (cargando) return <div>Cargando...</div>;

  return user?.role === "admin" ? <Outlet /> : <Navigate to="/login" replace />;
};

export default AdminRoute;
